import { styled } from 'styled-components';

import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

type ChevronProps = DefaultIconProps & {
  variant?: 'fat' | 'thin';
  direction?: 'upward' | 'downward' | 'left' | 'right';
};

export const ChevronIcon = ({
  width = 12,
  variant = 'fat',
  color = 'black',
  direction = 'right',
  marginLeft,
  marginRight,
  className,
  containerSize,
}: ChevronProps) => {
  let degrees = 0;
  if (direction === 'downward') {
    degrees = 90;
  } else if (direction === 'left') {
    degrees = 180;
  } else if (direction === 'upward') {
    degrees = 270;
  }

  return (
    <DefaultIconWrapper
      containerSize={containerSize}
      marginRight={marginRight}
      marginLeft={marginLeft}
      width={width}
      className={className}
    >
      <RotatedSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" degrees={degrees}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill={getSemanticTextColor(color)}
          d={
            variant === 'fat'
              ? 'M4.63928 3.75563C3.7869 2.89648 3.7869 1.50352 4.63928 0.644365C5.43839 -0.161091 6.70296 -0.211434 7.56025 0.493341L7.72602 0.644365L18 11L7.72602 21.3556C6.87364 22.2148 5.49166 22.2148 4.63928 21.3556C3.84018 20.5502 3.79023 19.2756 4.48945 18.4115L4.63928 18.2444L11.827 11L4.63928 3.75563Z'
              : 'M5.36562 21.642C4.93229 21.2177 4.88415 20.5592 5.22118 20.0828L5.36562 19.9135L14.4671 11L5.36562 2.08647C4.93229 1.66219 4.88415 1.0036 5.22117 0.527254L5.36562 0.357981C5.79894 -0.0662938 6.47158 -0.113434 6.95809 0.216556L7.13097 0.357981L18 11L7.13097 21.642C6.64348 22.1193 5.85311 22.1193 5.36562 21.642Z'
          }
        />
      </RotatedSvg>
    </DefaultIconWrapper>
  );
};

const RotatedSvg = styled.svg<{ degrees: number }>`
  transform: rotate(${props => props.degrees}deg);
`;
